import styles from './styles.module.scss';

import { useLocation, useNavigate } from 'react-router-dom';
import { ManagerIcon } from '../ManagerIcon';

export const LogicManagerSidebar = () => {
    const navigate = useNavigate();
    const currentPath = useLocation().pathname;

    const goToTrilogic = () => {
        if (currentPath !== '/') {
            console.clear();
            navigate('/');
        }
    };

    const goToManager = () => {
        if (currentPath !== '/manager') {
            console.clear();
            navigate('/manager');
        }
    };

    return (
        <div className={styles.sidebarContainer}>
            {currentPath !== '/' ? (
                <div
                    className={`${styles.option} ${styles.optionMain}`}
                    title='Trilogic'
                    onClick={goToTrilogic}
                >
                    <div className='fa fa-home' aria-hidden='true' />
                </div>
            ) : (
                <div
                    className={`${styles.option} ${styles.optionMain}`}
                    title='Gerenciamento da plataforma'
                    onClick={goToManager}
                >
                    <ManagerIcon className={styles.managerIcon} />
                </div>
            )}
        </div>
    );
};
